<template>
  <div class="min-h-screen bg-slate-50">
    <AddressSearchTypeahead @select="updateAddressItem" />
    <AddressDetails :address="addressItem" />
  </div>
</template>

<script>
import AddressSearchTypeahead from './components/AddressSearchTypeahead.vue'
import AddressDetails from './components/AddressDetails.vue'

export default {
  name: 'App',
  components: {
    AddressSearchTypeahead,
    AddressDetails
  },
  data() {
    return {
      addressItem: {}
    }
  },
  methods: {
    updateAddressItem(item) {
      this.addressItem = item
    }
  }
}
</script>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0f172a;
}
</style>
